import { create } from "zustand";
import { persist } from "zustand/middleware";
export interface ViewAsState {
	user: any | null;
	setUser: (value: any) => void;
	getUser: () => any;
	clearUser: () => void;
}

export type UserRole = {
	uuid: string;
	_isSupervisor?: string;
	_isAdmin?: string;
	_isItShopper?: string;
	_isGlobalAdmin?: string;
};

export const assignRole = (user: UserRole, hostname: string) => {
	if (hostname === "COMPASS") {
		if (user && user._isAdmin === "1") {
			return "admin";
		} else if (user && user._isSupervisor === "1") {
			return "superuser";
		} else {
			return "manager";
		}
	}
	if (hostname === "COMPASSCANADA") {
		if (user && user._isAdmin === "1") {
			return "admin";
		} else if (user && user._isSupervisor === "1") {
			return "superuser";
		} else {
			return "manager";
		}
	}

	if (hostname === "QUAD") {
		if (user && user._isGlobalAdmin === "1") {
			return "globalAdmin";
		} else if (user && user._isItShopper === "1") {
			return "itShopper";
		} else {
			return "buyer";
		}
	}
};

export const useUserStore = create<ViewAsState>()(
	persist(
		(set, get) => ({
			user: null,
			setUser: (user: any) => {
				set(() => ({
					user: user,
				}));
			},
			getUser: () => get().user,
			clearUser: () => {
				localStorage.removeItem("zu-user");
				set(() => ({
					user: null,
				}));
			},
		}),
		{
			name: "zu-user",
		},
	),
);
export default useUserStore;
